module.exports = __webpack_public_path__ + "static/media/A-Boomers.5f716b72.png";